import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import Bootbox from 'bootbox-react'
import React, { useEffect, useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import HeadToHeadService from 'src/service/HeadToHeadService'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import RoundService from 'src/service/RoundService'
import { Link } from 'react-router-dom'

const SetPlayOffSecond = (props) => {
  console.log('props.playOffMatch3', props.playOffMatch3)
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    round: Yup.string().required('Select round.'),
  })
  const formik = useFormik({
    initialValues: {
      round: props.playeOffSecond?.round_id,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      data.playOffNumber = 2
      HeadToHeadService.savePlayOffRound(data).then((res) => {
        if (res.success) {
          ToastComponent(res.message, 'success')
          setLoader(false)
        }
      })
    },
  })

  const [showConfirm, setShowConfirm] = useState(false)
  const [roundId, setRoundId] = useState(false)
  const [playeOfType, setPlayOffType] = useState(false)
  const showCofirmBox = (roundId = 0, type = 0) => {
    setRoundId(roundId)
    setPlayOffType(type)
    setShowConfirm(true)
  }

  const handleConfirm = () => {
    changeStatus()
    return setShowConfirm(false)
  }
  const handleCancel = () => {
    return setShowConfirm(false)
  }

  const changeStatus = (type) => {
    const data = {}
    data.roundId = props.playeOffSecond?.round_id
    data.playeOfType = playeOfType
    HeadToHeadService.finalizePlayOffSecond(data).then((res) => {
      if (res.success) {
        props.fetchData()
        ToastComponent(res.message, 'success')
      }
    })
  }
  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={6}>
          <CFormSelect
            aria-label="select round"
            name="round"
            className={
              'form-control' + (formik.errors.round && formik.touched.round ? ' is-invalid' : '')
            }
            defaultValue={formik.values.round}
            onChange={formik.handleChange}
            id="round"
          >
            <option value={0}>Select Round</option>
            {props.roundData &&
              props.roundData.map((item, key) => (
                <option value={item?.id} key={key}>
                  {item?.round}
                </option>
              ))}
          </CFormSelect>
          {formik.errors.round && formik.touched.round && (
            <CFormFeedback invalid>{formik.errors.round}</CFormFeedback>
          )}
        </CCol>

        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Save
          </CLoadingButton>
        </CCol>
      </CForm>
      <CRow>
        <CCol xs={12}>
          <CCard className="mt-3 mb-3">
            <CCardHeader>
              <strong>Matches</strong>
            </CCardHeader>
            <CCardBody>
              <p className="text-medium-emphasis small">Team Ranking Based matches</p>

              <CTable striped>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell className="text-center">Matches</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">First Opponent</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Second Opponent</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Winner</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {!props.playOffMatch3 && (
                    <CTableRow>
                      <CTableDataCell className="text-center">Match 3</CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.rankingData?.rank1Data?.fm_name ?? 'Rank 1'}
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch2?.winner ?? 'M2 Winner'}
                      </CTableDataCell>
                      <CTableDataCell className="text-center">-</CTableDataCell>
                    </CTableRow>
                  )}
                  {props.playOffMatch3 && (
                    <CTableRow>
                      <CTableDataCell className="text-center">Match 3</CTableDataCell>
                      <CTableDataCell className="text-center">
                        {props.playOffMatch3.fm_name}(
                        {props.playOffMatch3.total_points_first_member})
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch3.sm_name}(
                        {props.playOffMatch3.total_points_second_member})
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch3.winner}
                      </CTableDataCell>
                    </CTableRow>
                  )}

                  {!props.playOffMatch4 && (
                    <CTableRow>
                      <CTableDataCell className="text-center">Match 4</CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.rankingData?.rank2Data?.fm_name ?? 'Rank 2'}
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch1?.winner ?? 'M1 Winner'}
                      </CTableDataCell>
                      <CTableDataCell className="text-center">-</CTableDataCell>
                    </CTableRow>
                  )}
                  {props.playOffMatch4 && (
                    <CTableRow>
                      <CTableDataCell className="text-center">Match 4</CTableDataCell>
                      <CTableDataCell className="text-center">
                        {props.playOffMatch4.fm_name} (
                        {props.playOffMatch4.total_points_first_member})
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch4.sm_name}(
                        {props.playOffMatch4.total_points_second_member})
                      </CTableDataCell>
                      <CTableDataCell className="text-center">
                        {' '}
                        {props.playOffMatch4.winner}
                      </CTableDataCell>
                    </CTableRow>
                  )}
                </CTableBody>
              </CTable>
            </CCardBody>
          </CCard>
          <Link
            size="lg"
            className="btn btn-info btn-sm ms-1"
            onClick={() => showCofirmBox(roundId, 2)}
          >
            Finalize
          </Link>
        </CCol>
      </CRow>
      <Bootbox
        show={showConfirm}
        type={'confirm'}
        message={'Are you sure you want to finalize this?'}
        onSuccess={handleConfirm}
        onCancel={handleCancel}
        onClose={handleCancel}
      />
    </>
  )
}

export default SetPlayOffSecond
